module.exports = __webpack_public_path__ + "media/images/icons/flags/MP-36473ec48ee4eba0573838417ba2feb7.svg";